export default __webpack_public_path__ + "static/banner_bg-abf1b3deb0c6dcec0d13ba0a0111becd.webp";